import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Accordion, BaseFieldProps, Text } from '@frontend/design-system';
import { CALENDAR_TRACKING_IDS } from '../../../trackingIds/calendar-tracking-ids';
import { AppointmentStatusFilterList } from '../../ScheduleFilters/AppointmentStatusFilterList';
import { FilterCheckIcon } from '../../ScheduleFilters/FilterCount';

type CalendarViewV3HeaderConfirmationStatusFilterType = {
  confirmationStatusField: BaseFieldProps;
  defaultAppointmentStatusList: string[];
};

export const CalendarViewV3HeaderConfirmationStatusFilter = ({
  confirmationStatusField,
  defaultAppointmentStatusList,
}: CalendarViewV3HeaderConfirmationStatusFilterType) => {
  const { t } = useTranslation('scheduleCalendarFilters');

  const appointmentStatusSelectionCount =
    confirmationStatusField.value === 'all' ? false : !!confirmationStatusField.value;

  return (
    <Accordion shouldRenderBody size='large' showBoxShadow chevronSize={16}>
      <Accordion.Item
        value={'appointment status'}
        css={{ border: `1px solid ${theme.colors.neutral10}` }}
        trackingId={CALENDAR_TRACKING_IDS.headerBarFilter.appointmentStatusAccordion}
      >
        <Accordion.Header css={{ border: `1px solid ${theme.colors.neutral10}` }}>
          <Text size='medium' weight='bold' textAlign='left'>
            {t('Confirmation Status')}
          </Text>
          <FilterCheckIcon count={appointmentStatusSelectionCount} />
        </Accordion.Header>
        <Accordion.Body css={{ border: `1px solid ${theme.colors.neutral10}` }}>
          <AppointmentStatusFilterList
            appointmentStatuses={defaultAppointmentStatusList}
            appointmentStatusListProps={confirmationStatusField}
          />
        </Accordion.Body>
      </Accordion.Item>
    </Accordion>
  );
};
